import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  topText: {
    marginBottom: 20,
  },
  fieldRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    marginTop: theme.spacing(1),
  },
  nameField: {
    flex: 1,
    marginRight: theme.spacing(2),
  },
  addressField: {
    width: '75%',
  },
  cityField: {
    width: '50%',
    marginRight: theme.spacing(2),
  },
  stateField: {
    width: '20%',
    marginRight: theme.spacing(2),
    '& > .MuiFormControl-root': {
      margin: 0,
    },
  },
  zipCodeField: {
    width: 'auto',
    marginRight: theme.spacing(2),
    '& input[type=number]': {
      MozAppearance: 'textfield',
    },
    '& input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
  },
  ssnField: {
    minWidth: 172,
  },
  dateField: {
    margin: 0,
    marginRight: theme.spacing(2),
  },
  thumbsUp: {
    width: 175,
    height: 'auto',
  },
  verifyEmailSent: {
    width: 175,
    height: 'auto',
  },
  warningBox: {
    width: '100%',
    background: theme.palette.warning.light,
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius * 2,
    marginBottom: theme.spacing(2),
  },
  infoIcon: {
    marginLeft: theme.spacing(1),
    color: theme.palette.info.light,
  },
  ssnInfoIcon: {
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(3),
    color: theme.palette.info.light,
  },
  termsLink: {
    textDecorationLine: 'none',
    color: theme.palette.primary.main,
    display: 'inline-flex',
    alignItems: 'center',
    '&:hover': {
      textDecorationLine: 'underline',
    },
  },
  displayNone: {
    display: 'none',
  },
  tooltipPlacementOne: {
    marginLeft: 5,
    marginTop: -2,
  },
  tooltipPlacementTwo: {
    marginLeft: 5,
    marginTop: -22,
  },
  errorTab: {
    padding: `${theme.spacing(8)} ${theme.spacing(15)}`,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  errorWrapper: {
    color: 'inherit',
    fontSize: 'inherit',
  },
  errorCodeText: {
    color: 'inherit',
    fontStyle: 'italic',
    fontSize: 'inherit',
  },
  spinner: {
    opacity: 1,
    color: theme.palette.primary.main,
  },
}));

export default useStyles;
